import React, { useEffect, useState } from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { api } from "@/lib/api";
import { SEO } from "@/lib/seo";
import { Badge } from "@/components/ui/badge";
import { Award } from "lucide-react";

export default function VolunteerStoriesPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/volunteer-stories").then(setItems).catch(() => {}); }, []);
  return (
    <main>
      <SEO title="Volunteer Stories" description="Stories from CAF volunteers across India." breadcrumbs={[{name: "Home", href:"/"},{name:"Engage", href:"/volunteer"},{name:"Volunteer Stories", href:"/volunteer-stories"}]} />
      <PageHeader eyebrow="Volunteer Stories" title="Ordinary citizens, extraordinary impact." lead="Stories from our nationwide volunteer network — how they started, what they built." />
      <section className="container-wide py-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {items.map((s) => (
          <article key={s.id} className="rounded-2xl border border-border bg-background overflow-hidden card-lift" data-testid={`vstory-card-${s.slug}`}>
            <div className="aspect-[4/3] overflow-hidden"><img src={s.image} loading="lazy" alt={s.name} className="h-full w-full object-cover" /></div>
            <div className="p-5">
              <h3 className="heading-3 text-lg">{s.name}</h3>
              <div className="text-sm text-[hsl(var(--green))] font-semibold">{s.role}</div>
              <p className="text-sm text-[hsl(var(--muted-ink))] mt-2">{s.summary}</p>
              <p className="text-sm text-foreground mt-3 leading-relaxed">{s.story}</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {(s.badges || []).map((b) => (<Badge key={b} className="badge-orange border inline-flex items-center gap-1"><Award className="h-3 w-3" /> {b}</Badge>))}
              </div>
            </div>
          </article>
        ))}
      </section>
    </main>
  );
}
